import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"lighten-5 pt-0"},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"d-flex justify-center",attrs:{"cols":"5","sm":"4"}},[_c('span',[_vm._v("Sum of selected dice: "+_vm._s(_vm.sumOfSelectedDice))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }